import { CustomFlowbiteTheme } from 'flowbite-react';

// edited for borders (were used as dividers), text color and bg color (of header, body, footer)
export const modalTheme = (rounding = 'rounded-md', showCloseButton = true): CustomFlowbiteTheme['modal'] => {
    return {
        root: {
            base: 'fixed inset-x-0 top-0 z-50 h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full text-system-on-surface',
            show: {
                on: 'flex bg-gray-900/50 dark:bg-gray-900/80',
                off: 'hidden',
            },
            sizes: {
                sm: 'max-w-sm',
                md: 'max-w-md',
                lg: 'max-w-lg',
                xl: 'max-w-xl',
                '2xl': 'max-w-2xl',
                '3xl': 'max-w-3xl',
                '4xl': 'max-w-4xl',
                '5xl': 'max-w-5xl',
                '6xl': 'max-w-6xl',
                '7xl': 'max-w-7xl',
            },
            positions: {
                'top-left': 'items-start justify-start',
                'top-center': 'items-start justify-center',
                'top-right': 'items-start justify-end',
                'center-left': 'items-center justify-start',
                center: 'items-center justify-center',
                'center-right': 'items-center justify-end',
                'bottom-right': 'items-end justify-end',
                'bottom-center': 'items-end justify-center',
                'bottom-left': 'items-end justify-start',
            },
        },
        content: {
            base: 'relative w-full p-4', // remove h-full or modal moves to top on smaller view
            inner: `relative flex max-h-[90dvh] flex-col bg-white shadow dark:bg-gray-700 ${rounding}`,
        },
        body: {
            base: `flex-1 overflow-auto px-6 py-2 bg-system-surface ${rounding}`,
            popup: '',
        },
        header: {
            base: `flex items-center justify-between p-5 bg-system-surface ${rounding}`,
            popup: 'p-2',
            title: 'font-medium text-system-on-surface',
            close: {
                base: `${
                    showCloseButton ? '' : 'hidden'
                } ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white focus:outline-none focus:ring-1 focus:ring-system-outline shrink-0`,
                icon: 'h-5 w-5',
            },
        },
        footer: {
            base: `flex items-center space-x-2 p-6 bg-system-surface ${rounding}`,
            popup: '',
        },
    };
};

export const drawerModalTheme = (openModal: boolean, showCloseButton = true): CustomFlowbiteTheme['modal'] => {
    return {
        root: {
            base: 'fixed inset-0 z-50 flex items-end justify-center bg-gray-900/50 text-system-on-surface group transition-opacity duration-300',
            show: {
                on: 'flex',
                off: 'hidden',
            },
            sizes: {
                sm: 'max-w-sm',
                md: 'max-w-md',
                lg: 'max-w-lg',
                xl: 'max-w-xl',
                '2xl': 'max-w-2xl',
                '3xl': 'max-w-3xl',
                '4xl': 'max-w-4xl',
                '5xl': 'max-w-5xl',
                '6xl': 'max-w-6xl',
                '7xl': 'max-w-7xl',
            },
            positions: {}, // not needed using static bottom drawer
        },
        content: {
            base: 'relative w-full', // removed px-4, pb-6 or any padding here, removed h-full
            inner: `relative flex flex-col rounded-t-2xl bg-white shadow-lg transform transition-transform duration-300 ease-out ${
                openModal ? 'translate-y-0' : 'translate-y-full'
            } dark:bg-gray-700`,
        },
        body: {
            base: 'flex-1 overflow-y-auto px-4 py-2 bg-system-surface rounded-t-xl',
            popup: '',
        },
        header: {
            base: 'flex items-center justify-between rounded-t p-4 bg-system-surface',
            title: 'font-medium text-system-on-surface',
            close: {
                base: `${
                    showCloseButton ? '' : 'hidden'
                } ml-auto inline-flex items-center p-1.5 text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600`,
                icon: 'h-5 w-5',
            },
            popup: '',
        },
        footer: {
            base: 'flex items-center space-x-2 rounded-b p-4 bg-system-surface',
            popup: '',
        },
    };
};
